module.exports = {"210711004":"太和街道","210711008":"大薛街道","210711011":"新民街道","210711012":"营盘街道","210711013":"女儿河街道","210711071":"天桥街道","210711072":"杏山街道","210711073":"娘娘宫街道","210711080":"凌南街道","210711081":"松山街道","210711480":"锦州市果树农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210711.json
// module id = 641
// module chunks = 0